@if (userAccountRole === 'CLIENT_ADMIN') {
  <app-chart-widget
    [widgetPanelCharts]="widgetPanelChart"
    [widgetPanel]="{ style: {} }"
    [title]="title"
  ></app-chart-widget>
}

@if (userAccountRole === 'CLIENT_VENDOR_AND_SITES_MANAGER') {
  <app-title-content-widget [title]="'Vendor Ratings'">
    <ng-template #titleContentPanel>
      <div
        class="inner-panel cursor-select"
        (click)="navigateToVendorRatingsPage()"
      >
        <div class="row h-100 justify-content-center align-items-center">
          <div class="col-auto">
            <i class="mx-1 lh-0 bi bi-star-fill color-orange fs-45"></i>
            <i class="mx-1 lh-0 bi bi-star-fill color-orange fs-45"></i>
            <i class="mx-1 lh-0 bi bi-star-fill color-orange fs-45"></i>
            <i class="mx-1 lh-0 bi bi-star-fill color-orange fs-45"></i>
            <i class="mx-1 lh-0 bi bi-star-fill color-orange fs-45"></i>
          </div>
        </div>
      </div>
    </ng-template>
  </app-title-content-widget>
}
